import React from 'react';

interface Props {
  title: string;
  description: string;
  image: string;
  mobileImage: string;
  imageOnLeft?: boolean;
}

export const FeatureSection: React.FC<Props> = ({
  title,
  description,
  image,
  mobileImage,
  imageOnLeft = false,
}) => {
  const text = (
    <div className="flex flex-col gap-2 md:flex-1">
      <h3 className="text-title-24 text-foreground">{title}</h3>
      <p className="text-body-18 text-subtle-foreground">{description}</p>
    </div>
  );

  const mobileMedia = (
    <img src={mobileImage} alt="" className="w-full md:hidden" />
  );

  const desktopMedia = (
    <div className="relative hidden md:flex md:min-w-0 md:flex-1 md:items-center md:justify-center">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-4 inset-y-0 m-auto rounded-2xl bg-info-surface opacity-50 blur-[80px] dark:opacity-20"
      />
      <img src={image} alt="" className="relative w-full" />
    </div>
  );

  return (
    <div
      className={`flex flex-col gap-4 py-6 md:items-center md:gap-12 md:py-10 ${
        imageOnLeft ? 'md:flex-row-reverse' : 'md:flex-row'
      }`}
    >
      {text}
      {mobileMedia}
      {desktopMedia}
    </div>
  );
};
